<template>
  <div class="activityList">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div style="width: 1200px; margin: 0 auto; height: 53px">
      <div class="crumbs">
        <span>当前位置：</span>
        <span @click="toHome">首页 ></span>
        <span @click="toActivity">活动 ></span>
        <span style="color: #333333">{{ catalogueName }} </span>
      </div>
    </div>
    <div class="search-wrap">
      <div class="search-input">
        <input type="text" v-model="realName" placeholder="请输入关键字" />
        <button @click="search">搜索</button>
      </div>
    </div>
    <ul>
      <li v-for="(item, index) in list" :key="index" @click="toDetail(item.activityId)">
        <div class="li-wrap">
          <div style="width:370px;height:230px;overflow:hidden;float:left">
            <img class="hover" :src="item.coverImg" alt="" />
          </div>
          <div class="text">
            <div class="text-b">{{ item.activityName }}</div>
            <div class="text-s">{{ item.baseRemark }}</div>
            <div class="people">
              计划人数 ： <span style="color:#3476C1;font-size:16px;">{{ item.planNum }}</span>已报名：
              <span style="color:#3476C1;font-size:16px;">{{ item.registerNum }}</span>
            </div>
            <div class="date">
              截止日期 ：<span>{{ item.registerEndDateStr }}</span>
            </div>
          </div>
          <button class="detailBtn">
            查看详情
          </button>
        </div>
      </li>
    </ul>
    <div style="width: 100%; height: 30px"></div>
  </div>
</template>
<script>
import navigation from "@/components/common/navigation";
import { aiList } from "@/utils/AiActivity";

export default {
  name: "activityList",
  components: {
    navigation,
  },
  data() {
    return {
      catalogueName: "",
      catalogueEnglishName: "",
      catalogueId: "",
      list: [],
      realName: ''
    };
  },
  methods: {
    search() {
      // activityName 搜索
      let activityName = this.realName || this.$refs.content.value;
      let catalogueId = this.$route.query.id;
      if (catalogueId == 9999) {
        this.list = aiList.filter(item => {
          return item.activityName.indexOf(activityName) > -1
        })
      } else {
        this.$axios
          .post("/v1/cloud/common/activity/more", {
            catalogueId,
            activityName,
          })
          .then(({ data }) => {
            if (data) {
              this.list = data.activityList;
            }
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.message,
              type: "warning",
            });
          });
      }
    },
    toDetail(activityId) {
      let catalogueId = this.$route.query.id;
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId,
          catalogueId,
          catalogueName: this.catalogueName,
        },
      });
    },
    toHome() {
      sessionStorage.setItem("tabIndex", 1);
      this.$router.push("/");
    },
    toActivity() {
      this.$router.push("/activity");
    },
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    };

    // this.catalogueName = this.$route.query.catalogueName;
    // this.catalogueEnglishName = this.$route.query.catalogueEnglishName;

    let catalogueId = this.$route.query.id;
    if (catalogueId == 9999) {
      this.catalogueName = 'AI·数字智能';
      this.catalogueId = catalogueId
      this.list = aiList

    } else {
      this.$axios
        .post("/v1/cloud/common/activity/more", {
          catalogueId,
        })
        .then(({ data }) => {
          if (data) {
            this.catalogueName = data.catalogueName;
            this.catalogueEnglishName = data.catalogueEnglishName;
            this.catalogueId = data.catalogueId;
            this.list = data.activityList;
          }
        })
        .catch((error) => {
          this.$message({
            message: error.response.data.message,
            type: "warning",
          });
        });
    }

  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>
<style scoped lang="less">
img.hover {
  transition: all 1s
}

img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}

.search-wrap {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 30px;

  .search-input {
    margin-left: 61px;
    margin-bottom: 24px;

    input {
      width: 600px;
      outline: none;
      height: 40px;
      vertical-align: middle;
      text-indent: 11px;
      border: 1px solid #dddddd;
      box-sizing: border-box;
      border-radius: 3px;
    }

    input::placeholder {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }

    button {
      width: 100px;
      height: 40px;
      background: #3476c1;
      border-radius: 0px 3px 3px 0px;
      outline: none;
      border: none;
      text-align: center;
      line-height: 40px;
      margin-left: -1px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      vertical-align: middle;
      cursor: pointer;
    }
  }
}

.activityList {
  width: 100%;
  background-color: #f5f5f5;

  .crumbs {
    width: 500px;
    font-size: 14px;
    margin-top: 20px;

    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
    }
  }

  .inp {
    float: right;
    width: 550px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(16, 154, 242, 1);
    border-radius: 20px;

    input {
      width: 446px;
      height: 100%;
      float: left;
      border: none;
      outline: none;
      // color: #999;
      margin: 0 auto;
      // border-radius: 20px;
      margin-left: 20px;
      // margin-top: 10px;
    }

    button {
      // float: right;
      height: 39px;
      width: 80px;
      color: #fffffefe;
      border: none;
      outline: none;
      background-color: #109af2;
      // border-radius: 19px;
      border-top-right-radius: 19px;
      border-bottom-right-radius: 19px;
      margin-top: -1px;
      margin-right: -1px;
    }
  }

  ul {
    width: 1200px;
    list-style-type: none;
    margin: 30px auto;

    li {
      padding: 20px;
      width: 1200px;
      box-sizing: border-box;
      margin-bottom: 20px;
      background-color: #fff;
      font-family: MicrosoftYaHei;

      .li-wrap {
        height: 230px;
        width: 100%;
        position: relative;
        cursor: pointer;

        img {
          height: 230px;
          width: 370px;
          float: left;
        }

        .text {
          width: 760px;
          float: left;
          padding: 10px 20px 20px;

          .text-b {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-bottom: 11px;
          }

          .text-s {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .people {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            margin: 10px 0;

            span {
              color: #0f9bf1;
              font-size: 18px;
              margin-right: 64px;
            }
          }

          .date {
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
            font-family: MicrosoftYaHei;

            span {
              color: #333333;
            }
          }
        }

        .detailBtn {
          width: 150px;
          height: 40px;
          border: 1px solid #5fc0e4;
          border-radius: 3px;
          line-height: 40px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5fc0e4;
          outline: none;
          position: absolute;
          right: 30px;
          bottom: 20px;
          background-color: #fff;
        }

        .detailBtn:hover {
          color: #fff;
          background: rgba(0, 0, 0, 1);
        }
      }
    }

    li:hover {
      .li-wrap {
        background-color: #f5f5f5;

        .detailBtn {
          color: #fff;
          background-color: #5fc0e4;
        }
      }
    }
  }
}
</style>